import { CSSProperties, MouseEvent, ReactNode } from "react";

type TextHoverInlineButtonProps = {
  text: string;
  onPress: (e?: MouseEvent) => void;
  icon?: ReactNode;
  iconPosition?: "left" | "right";
  textStyles?: CSSProperties;
};

// Similar to TextHoverButton, but inline within a span instead of a button
const TextHoverInlineButton = (props: TextHoverInlineButtonProps) => {
  const { text, onPress, icon, iconPosition = "left", textStyles } = props;

  return (
    <span
      className="smallBodySubtext"
      onClick={onPress}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
      style={{
        display: "inline-flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        cursor: "pointer",
        ...textStyles,
      }}
    >
      {iconPosition === "left" && icon}
      {text}
      {iconPosition === "right" && icon}
    </span>
  );
};

export default TextHoverInlineButton;
